// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import promise from 'es6-promise'
promise.polyfill()
import 'babel-polyfill';
import './utils/prototype'
// 自定义名字enterMoney
Vue.directive('enterMoney', { 
  inserted: function (el) { 
    el.addEventListener('keypress', function (e) {
      e = e || window.event
      const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
      const re = /\d/
      if (charcode === 46) {
        // el.children[0].value是配合了el-input输入框使用的，使用input输入框时直接用el.value
        if (el.children[0].value.includes('.')) {
          e.preventDefault()
        }
        return
      } else if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault()
        } else {
          e.returnValue = false
        }
      }
    })
  }
})
Vue.config.productionTip = false
// 全局过滤器方法 迭代引入
import * as filters from './filters/index'
// 导出的是对象，可以直接通过 key 和 value 来获得过滤器的名和过滤器的方法
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
}) 
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'iKqH8YGy3lGvjVwTcKUb5KXlrvG8MOyC'
});

// 引入animate.css
import animated from 'animate.css' // npm install animate.css --save安装，在引入 
Vue.use(animated)
import './assets/css/main.css'  
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js